export const COLOR_MODE_SETTING_KEY = 'color_mode_setting'
